function inline(s) {
  const parts = s.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => (p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : p));
}

export default function Md({ text }) {
  const lines = text.split("\n");
  const out = [];
  let list = [];
  let table = [];
  const flush = () => {
    if (list.length) { out.push(<ul key={out.length}>{list.map((l, i) => <li key={i}>{inline(l)}</li>)}</ul>); list = []; }
    if (table.length) {
      const rows = table.filter((r) => !/^\s*\|?\s*-{2,}/.test(r)).map((r) => r.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim()));
      out.push(<table key={out.length}><tbody>{rows.map((r, i) => <tr key={i}>{r.map((c, j) => (i === 0 ? <th key={j}>{inline(c)}</th> : <td key={j}>{inline(c)}</td>))}</tr>)}</tbody></table>);
      table = [];
    }
  };
  lines.forEach((l) => {
    if (/^\s*\|/.test(l)) { table.push(l); return; }
    if (/^\s*[-*•]\s+/.test(l)) { list.push(l.replace(/^\s*[-*•]\s+/, "")); return; }
    flush();
    const h = l.match(/^(#{1,3})\s+(.*)/);
    if (h) out.push(<h3 key={out.length}>{inline(h[2])}</h3>);
    else if (l.trim()) out.push(<p key={out.length}>{inline(l)}</p>);
  });
  flush();
  return <>{out}</>;
}
